module.exports = __webpack_public_path__ + "static/media/SS4.7d5e0053.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Trip/SS4.jpeg
// module id = 276
// module chunks = 0